import { render } from "./ProductItemSmall.vue?vue&type=template&id=f4c6e75a&scoped=true"
import script from "./ProductItemSmall.vue?vue&type=script&lang=js"
export * from "./ProductItemSmall.vue?vue&type=script&lang=js"

import "./ProductItemSmall.vue?vue&type=style&index=0&id=f4c6e75a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c6e75a"]])

export default __exports__